angular
    .module('app')
    .component('serverHealth', {
        templateUrl: '/templates/pages/server-health/server-health.html',
        controller: 'ServerHealthController',
        controllerAs: 'vm',
    });